// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.4);
  height: 500px;
  flex-direction: column;
  margin: 0 auto;
  text-align: center;
}
.content .alert-sub-text {
  white-space: normal;
  max-width: 80%;
}

ion-icon {
  font-size: 55px;
}

ion-button {
  margin-top: 10px;
}

@media screen and (min-width: 992px) {
  .content {
    width: 500px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/general components/error-content/error-content.component.scss","webpack://./src/components/general%20components/error-content/error-content.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;ACCF;ADCE;EACE,mBAAA;EACA,cAAA;ACCJ;;ADGA;EACE,eAAA;ACAF;;ADGA;EACE,gBAAA;ACAF;;ADGA;EACE;IACE,YAAA;ECAF;AACF","sourcesContent":[".content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: rgb(0, 0, 0, 0.4);\n  height: 500px;\n  flex-direction: column;\n  margin: 0 auto;\n  text-align: center;\n\n  .alert-sub-text {\n    white-space: normal;\n    max-width: 80%;\n  }\n}\n\nion-icon {\n  font-size: 55px;\n}\n\nion-button {\n  margin-top: 10px;\n}\n\n@media screen and (min-width: 992px) {\n  .content {\n    width: 500px;\n  }\n}\n",".content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: rgba(0, 0, 0, 0.4);\n  height: 500px;\n  flex-direction: column;\n  margin: 0 auto;\n  text-align: center;\n}\n.content .alert-sub-text {\n  white-space: normal;\n  max-width: 80%;\n}\n\nion-icon {\n  font-size: 55px;\n}\n\nion-button {\n  margin-top: 10px;\n}\n\n@media screen and (min-width: 992px) {\n  .content {\n    width: 500px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
